module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "landing-header"
  }, [_c('div', {
    staticClass: "inner-container"
  }, [_vm._m(0), _vm._v(" "), _c('ul', {
    staticClass: "menu",
    attrs: {
      "id": _vm.mobileMenuId
    }
  }, [_c('li', {
    staticClass: "menu-item",
    attrs: {
      "data-target": "#inicio"
    },
    on: {
      "click": _vm.goToSection
    }
  }, [_vm._v("Inicio")]), _vm._v(" "), _c('li', {
    staticClass: "menu-item",
    attrs: {
      "data-target": "#depoimentos"
    },
    on: {
      "click": _vm.goToSection
    }
  }, [_vm._v("Depoimentos")]), _vm._v(" "), _c('li', {
    staticClass: "menu-item",
    attrs: {
      "data-target": "#clientes"
    },
    on: {
      "click": _vm.goToSection
    }
  }, [_vm._v("Clientes")]), _vm._v(" "), _c('li', {
    staticClass: "menu-item",
    attrs: {
      "data-target": "#como-trabalhamos"
    },
    on: {
      "click": _vm.goToSection
    }
  }, [_vm._v("Como Trabalhamos")]), _vm._v(" "), _c('li', {
    staticClass: "menu-item",
    attrs: {
      "data-target": "#escritorio"
    },
    on: {
      "click": _vm.goToSection
    }
  }, [_vm._v("Escritório")]), _vm._v(" "), _c('li', {
    staticClass: "menu-item",
    attrs: {
      "data-target": "#open-source"
    },
    on: {
      "click": _vm.goToSection
    }
  }, [_vm._v("Open Source")]), _vm._v(" "), _c('li', {
    staticClass: "menu-item",
    attrs: {
      "data-target": "#vagas"
    },
    on: {
      "click": _vm.goToSection
    }
  }, [_vm._v("Vagas")])]), _vm._v(" "), _c('button', {
    staticClass: "mobile-menu-button",
    on: {
      "click": _vm.showMobileMenu
    }
  }, [_c('span', {
    staticClass: "moip-icon moip-icon-bars"
  }), _vm._v(" "), _c('span', {
    staticClass: "hide-me"
  }, [_vm._v("Menu")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "moip-logo"
  }, [_c('span', [_vm._v("Moip | a wirecard company")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-305fcf20!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LandingHeader.vue
// module id = 134
// module chunks = 1